import { DataGrid, esES } from '@mui/x-data-grid';

export const DataTableCustom = ({
    rows,
    columns,
    pageSizeOptions = { pageSize: 10, page: 0, totalRows: 0 },
    onPageChange,
    // handleRowClick
}) => {
    return (
        <DataGrid
            rows={rows}
            columns={columns}
            // onRowClick={handleRowClick}
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: pageSizeOptions.pageSize,
                        page: pageSizeOptions.page                        
                    },
                },
            }}
            pageSizeOptions={[10, 15, 25]}
            rowCount={pageSizeOptions.totalRows ?? 0}
            paginationMode="server"
            paginationModel={pageSizeOptions}
            onPaginationModelChange={(model) => onPageChange(model)}
        />
    )
}
